module.exports = __webpack_public_path__ + "static/img/huiyishiyongpin.788182a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huiyishiyongpin.png
// module id = lK3h
// module chunks = 0